exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".picture[data-v-35d47d8a]{display:block}.picture img[data-v-35d47d8a]{width:100%;height:100%;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/workspace/source-code/src/assets","/static":"/workspace/source-code/src/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35d47d8a","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Picture.vue
// module id = XgjI
// module chunks = 12